import React from 'react'
import CurrencyExchangeComponent from '../../../components/CurrencyConversion/CurrencyConverter'

const Converter = () => {
  return (
    <section className='main p-md-2 p-1'>
      <div className="container-fluid mt-4 px-0">
        <CurrencyExchangeComponent />
      </div>
    </section>
  )
}

export default Converter